import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/paperspace/caldiy-private/releases/20260927-pilot-01/apps/web/modules/auth/forgot-password/forgot-password-view.tsx");
